import { Model, createPresets, createRecipe } from 'jms-domain'

import { type DomainEntityId } from '@salsita-ai/platform-project-sdk/domain'

const defaultWallLength = 200 * 25.4

export const presets = createPresets([
  {
    name: 'First Preset',
    description: 'Simple kitchen configuration',
    rootEntityType: 'Room',
    initialDomainEntities: [
      createRecipe({
        id: 'Room-1' as DomainEntityId<'Room'>,
        type: 'Room',
        shape: 'U' as Model.RoomShapeType,
        cabinetColor: 'Obsidian',
        fuelType: Model.FuelType.Propane,
        powderCoatType: Model.PowderCoatType.Swatch,
        stainlessSafeEnvironment: false,
      }),
      createRecipe({
        id: 'Wall-1' as DomainEntityId<'Wall'>,
        type: 'Wall',
        wallType: 'A',
        length: defaultWallLength,
        fullHeight: true,
        hidden: false,
      }),
      createRecipe({
        id: 'Wall-2' as DomainEntityId<'Wall'>,
        type: 'Wall',
        wallType: 'B',
        length: defaultWallLength,
        fullHeight: true,
        hidden: false,
      }),
      createRecipe({
        id: 'Wall-3' as DomainEntityId<'Wall'>,
        type: 'Wall',
        wallType: 'C',
        length: defaultWallLength,
        fullHeight: true,
        hidden: false,
      }),
      createRecipe({
        id: 'CornerFiller-1' as DomainEntityId<'CornerFiller'>,
        type: 'CornerFiller',
        cornerFillerType: 'AB',
      }),
      createRecipe({
        id: 'CornerFiller-2' as DomainEntityId<'CornerFiller'>,
        type: 'CornerFiller',
        cornerFillerType: 'BC',
      }),
    ],
  },
])
